import { RowSkeleton } from '../../HoldingsTableRow';
import { Table } from '../../Table';

export const HoldingsTableLoading = () => (
  <Table>
    <RowSkeleton />
    <RowSkeleton />
    <RowSkeleton />
  </Table>
);
